import { createContext } from 'react';
import type { AttributionTokensSchema } from 'src/models/attributionTokens/schema';
import type { ReviewFormState } from 'src/models/product/schema';
import type { Cache } from 'src/services/cache';

export type CacheStore = {
  shopId: Cache<number | undefined>;
  checkedFavList: Cache<{ [key: string]: boolean } | null>;
  couponHistoryId: Cache<number>;
  savedReviewFormData: Cache<ReviewFormState | null>;
  pinchOutPopupShownDate: Cache<string | null>;
  cachedAttributionTokens: Cache<AttributionTokensSchema | undefined>;
};

export const BrowserCacheContext = createContext<CacheStore>({} as CacheStore);
